<div class="single-signup-res">
    <!-- Asset Profile Image Upload -->
    <div class="profileImgContainer">
        <div class="p-g-3 p-md-4 imgstyle">
            <img style="width: 200px; height: 200px" [src]="
              asset.profile
                ? asset.profile
                : 'assets/layout/images/2.png'
            " alt="Asset Profile Picture" />
        </div>
        <div class="userDetailToolBar">
            <h3 class="first">{{setLabel("assetPictureLabel")}}</h3>
            <button (click)="captureImageDialogShow('Cam')" style="height: 2rem;width: 7rem;display: flex;align-items: center;justify-content: center;">
                <span class="button p-button-text p-c">
                    <i class="fa fa-camera" aria-hidden="true"></i>
                    &nbsp;{{setLabel("captureLabel")}}
                </span>
            </button>
            <button (click)="captureImageDialogShow('Upload')" style="height: 2rem;width: 7rem;display: flex;align-items: center;justify-content: center;">
                <span class="button p-button-text p-c">
                    <i class="fa fa-upload" aria-hidden="true"></i>
                    &nbsp;{{setLabel("uploadLabel")}}
                </span>
            </button>
            <button (click)="removeProfileImage()" style="height: 2rem;width: 7rem;display: flex;align-items: center;justify-content: center;" class="removePhoto">
                <span class="button p-button-text p-c">
                    <i class="fa fa-times"></i>
                    &nbsp;{{setLabel("removeLabel")}}
                </span>
            </button>
        </div>
    </div>
    <!-- Asset Input Form -->
    <form #assetForm="ngForm">
        <div class="p-g-12 single-signup-detail-1-res">
            <div class="p-g-6" style="text-align: left">
                <div class="p-g p-fluid">
                    <!-- Name -->
                    <h3 class="first">
                        {{setLabel("assetNameLabel")}}
                        <span style="color: red">*</span>
                    </h3>
                    <div class="p-g-12">
                        <div class="p-inputgroup">
                            <span class="p-inputgroup-addon"><i class="fa fa-user" aria-hidden="true"></i></span>
                            <input maxlength="100" autocomplete="off" id="name" required name="name" pattern="[A-Za-z ]+"
                            [ngClass]="
                            name.invalid &&
                            (name.dirty ||
                                name.touched)
                                ? 'errorInput'
                                : ''"
                            type="text" [(ngModel)]="asset.name"
                            #name="ngModel"  [placeholder]='setLabel("enterAssetNamePlaceholder")' />
                        </div>
                        <div *ngIf="
                        name.invalid &&
                        (name.dirty || name.touched)
                    ">
                        <div *ngIf="name.errors.required" class="errorShow">
                            {{setLabel("pleaseEnterNameLabel")}}
                        </div>
                        <div *ngIf="name.errors.pattern" class="errorShow">
                            {{setLabel("pleaseEnterCorrectNameLabel")}}
                        </div>
                    </div>
                    </div>
                    <!-- Category -->
                    <h3 class="first">
                        {{setLabel("categoryLabel")}}
                        <span style="color: red">*</span>
                    </h3>
                    <div class="p-g-12">
                        <div class="p-inputgroup">
                        <span class="p-inputgroup-addon">
                            <i class="fa fa-user" aria-hidden="true"></i>
                        </span>
                        <p-dropdown
                            [options]="categories"
                            [(ngModel)]="asset.category"
                            [placeholder]='setLabel("selectCategoryPlaceholder")'
                            name="category"
                            id="category"
                            required
                            #categoryDropdown="ngModel"
                            [style]="{ width: '100%' }"
                            [ngClass]="categoryDropdown.invalid && (categoryDropdown.dirty || categoryDropdown.touched) ? 'errorInput' : ''">
                        </p-dropdown>
                        </div>
                        <!-- Validation messages -->
                        <div *ngIf="categoryDropdown.invalid && (categoryDropdown.dirty || categoryDropdown.touched)">
                        <div *ngIf="categoryDropdown.errors?.required" class="errorShow">
                            {{setLabel("pleaseSelectCategoryLabel")}}
                        </div>
                        </div>
                    </div>
                    <!-- Purchase Date -->
                    <h3 class="first">{{setLabel("purchaseLabel")}}</h3>
                    <div class="p-g-12">
                        <div class="p-inputgroup">
                            <p-calendar [yearNavigator]="true" autofocus="true" inline="true" yearRange="1950:2040"
                                [monthNavigator]="true" [(ngModel)]="asset.purchaseDate" id="purchaseDate"
                                [placeholder]='setLabel("purchaseDatePlaceholder")' name="purchaseDate" [inline]="false" dateFormat="dd/mm/yy"
                                [showIcon]="true">
                            </p-calendar>
                        </div>
                    </div>
                    <!-- Status (Radio Buttons) -->
                    <h3 class="first">{{setLabel("statusLabel")}}</h3>
                    <div class="p-g-12">
                        <div class="p-inputgroup">
                            <div class="p-g-6">
                                <p-radioButton
                                    name="status"
                                    [value]='setLabel("activeValueLabel")'
                                    [(ngModel)]="asset.status"
                                    inputId="statusActive"
                                    label="Active"
                                    [ngClass]="asset.status === 'Active' ? 'radioBtnHighlite' : ''">
                                </p-radioButton>
                            </div>
                            <div class="p-g-6">
                                <p-radioButton
                                    name="status"
                                    [value]='setLabel("inactiveValueLabel")'
                                    [(ngModel)]="asset.status"
                                    inputId="statusInactive"
                                    label="Inactive"
                                    [ngClass]="asset.status === 'Inactive' ? 'radioBtnHighlite' : ''">
                                </p-radioButton>
                            </div>
                        </div>
                    </div>
                </div> <!-- LEFT DIV -->
            </div>
            <div class="p-g-6" style="text-align: left">
                <div class="p-g p-fluid">
                    <!-- Cost -->
                    <h3 class="first">{{setLabel("costLabel")}}</h3>
                    <div class="p-g-12">
                        <div class="p-inputgroup">
                            <input type="number" id="cost" name="cost" [(ngModel)]="asset.cost"
                                [placeholder]='setLabel("enterAssetCostPlaceholder")' />
                        </div>
                    </div>
                    <!-- Serial Number -->
                    <h3 class="first">{{setLabel("serialNumberLabel")}}</h3>
                    <div class="p-g-12">
                        <div class="p-inputgroup">
                            <input type="text" id="serialNumber" name="serialNumber" [(ngModel)]="asset.serialNumber"
                                [placeholder]='setLabel("enterSerialNumberPlaceholder")' />
                        </div>
                    </div>
                    <!-- Description -->
                    <h3 class="first">{{setLabel("descriptionLabel")}}</h3>
                    <div class="p-g-12">
                        <div class="p-inputgroup">
                            <textarea id="description" name="description" [(ngModel)]="asset.description"
                                [placeholder]='setLabel("enterAssetDescriptionPlaceholder")'></textarea>
                        </div>
                    </div>
                    <!-- Warranty Expiry Date -->
                    <h3 class="first">{{setLabel("warrantyExpiryDateLabel")}}</h3>
                    <div class="p-g-12">
                        <div class="p-inputgroup">
                            <p-calendar [yearNavigator]="true" autofocus="true" yearRange="1950:2040"
                                [monthNavigator]="true" [(ngModel)]="asset.warrantyExpiry" id="expiryDate"
                                [placeholder]='setLabel("warrantExpiryDatePlaceholder")' name="expiryDate" dateFormat="dd/mm/yy"
                                [showIcon]="true">
                            </p-calendar>
                        </div>
                    </div>
                    <!-- Form Buttons -->
                    <div class="p-g-12">
                        <input type="button" id="save" style="width: 147px !important; border-radius: 5px"
                        (click)="validateAssetSignup(assetForm)" [disabled]=""
                        class="p-button p-widget p-state-default p-corner-all" [value]='setLabel("saveValueLabel")' />
                        &nbsp;&nbsp;
                    </div>
                </div>
            </div>
        </div>
    </form>
    <div *ngIf="dialogVisibility" class="tecfolkProfileDialogFix">
        <p-dialog [header]='setLabel("assetProfilePictureHeaderLabel")' [(visible)]="dialogVisibility" class="app-add-profile-image-tecfolk-fix">
            <app-add-profile-image [popupType]="addProfileImage" (closeThePopup)="hideAddProfileImage()"
                (outputImage)="handleImagefromNewProfile($event)"></app-add-profile-image>
        </p-dialog>
        <!-- popupType : Upload | Cam -->
    </div>

</div>